module.exports = __webpack_public_path__ + "static/media/algorithm.cf1022e2.svg";